import * as R from 'ramda';
import { CustomError } from '../../../common/errors';

export default class AuthenticationLockedError extends CustomError {}

export const isAuthenticationLockedError = (error: Error): boolean => {
  return R.is(AuthenticationLockedError, error);
};
